import {View} from "vritra";
import css from "./SendButton.module.css";
import {paperplane0} from "Assets";


export default function SendButton(props){
    const {parent,label="send",tintColor="white"}=props;
    const sendbutton=View({
        parent,tag:"button",
        className:css.sendbutton,
        style:props.style,
    });

    sendbutton.innateHTML=`
        <img src="${paperplane0(tintColor)}"/>
        <label style="color:${tintColor}">${label}</label>
    `;

    return sendbutton;
}
